"use strict";

var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createSurvey = createSurvey;
exports.deleteSurveyById = deleteSurveyById;
exports.getHikeParticipantBySurveyId = getHikeParticipantBySurveyId;
exports.getLPSurvey = getLPSurvey;
exports.getMGHSurveyBossPeerDMList = getMGHSurveyBossPeerDMList;
exports.getRespondentFeedback = getRespondentFeedback;
exports.getSurveyById = getSurveyById;
exports.getSurveyIsInUse = getSurveyIsInUse;
exports.getSurveyList = getSurveyList;
exports.saveLPSurvey = saveLPSurvey;
exports.updateSurveyById = updateSurveyById;
var _request = _interopRequireDefault(require("@/utils/request"));
function getSurveyList(token, query) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  return (0, _request.default)({
    url: '/survey',
    baseURL: process.env.VUE_APP_SURVEY_API_DOMAIN,
    method: 'get',
    headers,
    params: query
  });
}
function getSurveyById(token, id) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  return (0, _request.default)({
    url: '/survey/' + id + '/builder',
    baseURL: process.env.VUE_APP_SURVEY_API_DOMAIN,
    method: 'get',
    headers
  });
}
function getSurveyIsInUse(token, id) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  return (0, _request.default)({
    url: '/survey/is-in-use/' + id,
    baseURL: process.env.VUE_APP_SURVEY_API_DOMAIN,
    method: 'get',
    headers
  });
}
function createSurvey(token, formData) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  const data = formData;
  return (0, _request.default)({
    url: '/survey',
    baseURL: process.env.VUE_APP_SURVEY_API_DOMAIN,
    method: 'post',
    headers,
    data
  });
}
function updateSurveyById(token, id, formData) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  const data = formData;
  return (0, _request.default)({
    url: '/survey/' + id,
    baseURL: process.env.VUE_APP_SURVEY_API_DOMAIN,
    method: 'put',
    headers,
    data
  });
}
function deleteSurveyById(token, id) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  return (0, _request.default)({
    url: '/survey/' + id,
    baseURL: process.env.VUE_APP_SURVEY_API_DOMAIN,
    method: 'delete',
    headers
  });
}
function getHikeParticipantBySurveyId(token, id) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  return (0, _request.default)({
    url: '/survey/' + id + '/participants',
    baseURL: process.env.VUE_APP_SURVEY_API_DOMAIN,
    method: 'get',
    headers
  });
}
function getMGHSurveyBossPeerDMList(token, id) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  return (0, _request.default)({
    url: '/survey/' + id + '/mgh-boss-peer-dm',
    baseURL: process.env.VUE_APP_SURVEY_API_DOMAIN,
    method: 'get',
    headers
  });
}
function getLPSurvey(token, query) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  return (0, _request.default)({
    url: '/user-lp-survey/list',
    baseURL: process.env.VUE_APP_SURVEY_API_DOMAIN,
    method: 'get',
    headers,
    params: query
  });
}
function saveLPSurvey(token, formData) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  const data = formData;
  return (0, _request.default)({
    url: '/user-lp-survey/save',
    baseURL: process.env.VUE_APP_SURVEY_API_DOMAIN,
    method: 'post',
    headers,
    data
  });
}
function getRespondentFeedback(token, formData) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  const data = formData;
  return (0, _request.default)({
    url: '/user-survey/mgh/respondent-feedback',
    baseURL: process.env.VUE_APP_SURVEY_API_DOMAIN,
    method: 'post',
    headers,
    data
  });
}